import { useContext, useEffect, useState } from 'react'
import Tabing from './tabing'
import SearchPopup from './popup/SearchPopup';
import { GlobalContext } from '../../../../../context/Context';

const BottomHeader = ({ bottomTabs, style, className }) => {
    let { state } = useContext(GlobalContext);
    const [isSearchOpen, setSearchOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();
                setSearchOpen(true);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <>
            <div className={`${style.bottomHeader} ${className?.bottomHeader}`}>
                <Tabing bottomTabs={bottomTabs} style={style} className={className} />
                {/* {state?.user?.employee_id != "23532" ?
                    <div className={`${style.headerBottom_search} ${className?.headerBottom_search}`} onClick={() => setSearchOpen(true)}>
                        <div className={`${style.SearchIcon} ${className?.SearchIcon}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M16.5 16.5L13.5834 13.5833M15.6667 8.58333C15.6667 12.4954 12.4954 15.6667 8.58333 15.6667C4.67132 15.6667 1.5 12.4954 1.5 8.58333C1.5 4.67132 4.67132 1.5 8.58333 1.5C12.4954 1.5 15.6667 4.67132 15.6667 8.58333Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>

                        <input type="text" placeholder='Search' />
                        <span className={`${className?.SearchShortCut} ${style.SearchShortCut}`}>⌘K</span>
                    </div>
                    :
                    null
                } */}
            </div>

            <SearchPopup isOpen={isSearchOpen} onClose={() => setSearchOpen(false)} />
        </>
    )
}

export default BottomHeader
